import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { DATA_TYPE_TO_EVENT_VERSION } from "components/saved_searches/utils";
import { graphql } from "lib/generated/app-service-gql";
import {
  DeleteSavedViewsMutation,
  DeleteSavedViewsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../../useGraphQlClient";

const deleteSavedViews = graphql(`
  mutation DeleteSavedViews($request: DeleteSavedViewsRequest!) {
    deleteSavedViews(DeleteSavedViewsRequest: $request) {
      id
      name
      dataType
      view
    }
  }
`);

export function useDeleteSavedViews(
  options?: UseMutationOptions<
    DeleteSavedViewsMutation,
    unknown,
    DeleteSavedViewsMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { logEvent } = useTracking();

  const { data, ...rest } = useGraphQlMutation(deleteSavedViews, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: ["savedViews"] });
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptionContents"] });
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptions"] });
      options?.onSuccess && options?.onSuccess(data, variables, context);

      for (const view of data.deleteSavedViews) {
        logEvent(EventNames.viewDeleted, {
          "Saved view name": view.name,
          "Saved view id": view.id,
          "Data type": DATA_TYPE_TO_EVENT_VERSION[view.dataType],
        });
      }
    },
  });

  return { data: data?.deleteSavedViews, ...rest };
}
